
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, ChangeDetectionStrategy, SimpleChanges, OnChanges } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

@Component({
    selector: 'app-top-n-table',
    templateUrl: './top-n-table.component.html',
    styleUrls: ['./top-n-table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopNTableComponent implements OnInit, OnDestroy, OnChanges {
    @Input()
    configs: TopNTableConfig[]
    @Input()
    previewCount = 3;
    @Input()
    showExpansion = true;
    @Input()
    showHistory = true;

    previewColumnNames: string[];
    initialized = false;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.initialized = false;
        if (this.configs) {
            this.configs
                .forEach((config: TopNTableConfig) => {
                    const previewLabels = [];
                    for (let i = 0; i < this.previewCount && i < config.data.length; i++) {
                        previewLabels.push(config.data[i].label);
                    }
                    config['previewLabels'] = previewLabels;
                })
            this.previewColumnNames = [];
            for (let i = 1; i <= this.previewCount; i++) {
                this.previewColumnNames.push(`#${i}`);
            }
            this.initialized = true;
        }
    }
    ngOnDestroy() {
    }

    onRowExpand(event) {
        const index = this.configs.findIndex((config: TopNTableConfig) => {
            return config.subject === event.data.subject;
        });
        if (index > -1) {
            setTimeout(() => {
                this.createChart(index);
            }, 300);
        }
    }

    createChart(index: number) {
        // Apply the themes
        const topToColor = {};
        const colorSet = new am4core.ColorSet();
        // Heat Chart
        const heatChartData = this.configs[index].data
            .map((data: TopNTableData) => {
                topToColor[data.label] = colorSet.next();
                return {
                    name: data.label,
                    value: Math.abs(data.values[0]),
                    color: topToColor[data.label],
                }
            })
            .sort((d1, d2) => {
                return d1.value > d2.value ? -1 : 1;
            });
        const heatChart = am4core.create('heatchartdiv' + index, am4charts.TreeMap);
        heatChart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
        heatChart.data = heatChartData;
        heatChart.dataFields.name = 'name';
        heatChart.dataFields.value = 'value';
        heatChart.logo.visible = false;
        heatChart.dataFields.color = 'color';

        const level0 = heatChart.seriesTemplates.create('0');
        const level0Column = level0.columns.template;
        level0Column.column.cornerRadius(10, 10, 10, 10);
        level0Column.fillOpacity = 0.8;
        level0Column.stroke = am4core.color('#fff');
        level0Column.strokeWidth = 5;
        level0Column.strokeOpacity = 1;
        const level0Bullet = level0.bullets.push(new am4charts.LabelBullet());
        level0Bullet.locationY = 0.5;
        level0Bullet.locationX = 0.5;
        level0Bullet.label.text = '{name}';
        level0Bullet.label.fill = am4core.color('#fff');


        // const container = am4core.create('historicalchartdiv' + index, am4core.Container);
        // container.logo.visible = false;
        // container.layout = 'vertical';
        // container.fixedWidthGrid = false;
        // container.width = am4core.percent(100);
        // container.height = am4core.percent(100);





        // Historical Chart
        const historicalChart = am4core.create('historicalchartdiv' + index, am4charts.XYChart);
        historicalChart.logo.visible = false;
        historicalChart.dateFormatter.inputDateFormat = 'yyyy-MM-dd';
        const historicalTitle = historicalChart.titles.create();
        historicalTitle.text = 'Historical Rankings';

        // Create axes
        const categoryAxis = historicalChart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = 'date';
        categoryAxis.renderer.opposite = true;

        const valueAxis = historicalChart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.inversed = true;
        valueAxis.renderer.minLabelPosition = 0.01;
        valueAxis.maxPrecision = 0;

        const historicalChartDataByDate = {};
        const tops = Object.keys(this.configs[index].historicalDataByTop);
        for (let topIndex = 0; topIndex < tops.length; topIndex++) {
            const top = tops[topIndex];
            // ((top: string, topIndex: number) => {
            const historicalData = this.configs[index].historicalDataByTop[top];
            historicalData
                .forEach((hd) => {
                    const chartData = historicalChartDataByDate[hd.date] || {
                        date: hd.date,
                    };
                    historicalChartDataByDate[hd.date] = chartData;
                    chartData[`rank${topIndex}`] = hd.rank;
                    chartData[`value${topIndex}`] = hd.value;
                    chartData[`color${topIndex}`] = topToColor[top];
                });
            // const chart = container.createChild(am4charts.XYChart);
            // chart.width = am4core.percent(90);
            // chart.height = 70;

            // chart.data = data;

            // // chart.titles.template.fontSize = 10;
            // // chart.titles.template.textAlign = 'start';
            // // chart.titles.template.isMeasured = false;
            // // chart.titles.create().text = top;

            // // chart.padding(20, 5, 2, 5);

            // const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            // dateAxis.renderer.grid.template.disabled = true;
            // dateAxis.renderer.labels.template.disabled = true;
            // dateAxis.startLocation = 0.5;
            // dateAxis.endLocation = 0.7;
            // dateAxis.cursorTooltipEnabled = false;

            // const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            // valueAxis.min = 0;
            // valueAxis.renderer.grid.template.disabled = true;
            // valueAxis.renderer.baseGrid.disabled = true;
            // valueAxis.renderer.labels.template.disabled = true;
            // valueAxis.cursorTooltipEnabled = false;

            // chart.cursor = new am4charts.XYCursor();
            // chart.cursor.lineY.disabled = true;
            // chart.cursor.behavior = 'none';

            // const series = chart.series.push(new am4charts.ColumnSeries());
            // series.tooltipText = '{date}: [bold]{value}';
            // series.dataFields.dateX = 'date';
            // series.dataFields.valueY = 'value';
            // // series.tensionX = 0.8;
            // series.strokeWidth = 2;
            // // series.stroke = color;

            // // render data points as bullets
            // const bullet = series.bullets.push(new am4charts.CircleBullet());
            // bullet.circle.opacity = 0;
            // // bullet.circle.fill = color;
            // bullet.circle.propertyFields.opacity = 'opacity';
            // bullet.circle.radius = 3;



            // Create series
            const series = historicalChart.series.push(new am4charts.LineSeries());
            series.name = top;
            series.dataFields.valueY = `rank${topIndex}`;
            series.dataFields.categoryX = 'date';
            series.propertyFields.stroke = `color${topIndex}`;
            series.propertyFields.fill = `color${topIndex}`;
            series.tooltipText = `#{rank${topIndex}} - ${top}: {value${topIndex}}`;
            series.strokeWidth = 2;
            // series.minBulletDistance = 15;
            // series.bullets.push(new am4charts.CircleBullet());

            // Drop-shaped tooltips
            // series.tooltip.background.cornerRadius = 20;
            // series.tooltip.background.strokeOpacity = 0;
            // series.tooltip.pointerOrientation = 'vertical';
            // series.tooltip.label.minWidth = 40;
            // series.tooltip.label.minHeight = 40;
            // series.tooltip.label.textAlign = 'middle';
            // series.tooltip.label.textValign = 'middle';
        }
        // )
        const historicalChartData = [].concat(Object.values(historicalChartDataByDate));
        historicalChart.data = historicalChartData;
        historicalChart.cursor = new am4charts.XYCursor();
        historicalChart.cursor.behavior = 'zoomY';
    }

    onRowSelect(event) {

    }
}

export interface TopNTableConfig {
    subject: string;
    columnNames: string[];
    data: TopNTableData[];
    historicalDataByTop: { [key: string]: TopNHistoricalData[] };
}

export interface TopNTableData {
    label: string;
    values: any[];
}

export interface TopNHistoricalData {
    date: string;
    value: number;
    rank: number;
}
